import { dateToFrontEndFormat } from 'common/utils/dateHelpers';
import { _calculateStatusTooltipMessage, getUTMsStatusTooltipProps } from 'common/utils/statusHelpers';
import { getActiveStatus, getInactiveStatus } from 'common/utils/userMembershipColumnsHelper';

import { TenantUserMembershipGetPaginatedSingleResponse } from './TenantUserMembershipApiTypeDefs';

export const _formatTenantUserMembershipResponse = (rows: TenantUserMembershipGetPaginatedSingleResponse[]) => {
    return rows.map(item => {
        const statusTooltipProps = getUTMsStatusTooltipProps(item);
        return {
            ...item,
            id: item.userId,
            firstName: item.profile?.firstName || 'Unknown',
            lastName: item.profile?.lastName || 'User',
            principalName: item.profile?.principalName || 'Unknown',
            email: item.profile?.email,
            companyKey: item.profile?.companyKey,
            globalRoles: item.globalRoles?.map(elem => elem.name).join(', '),
            isActive: item.isActive ? getActiveStatus() : getInactiveStatus(),
            status: item.status,
            rawGlobalRoles: item.globalRoles,
            startDate: item.startDate && dateToFrontEndFormat(item.startDate),
            endDate: item.endDate && dateToFrontEndFormat(item.endDate),
            tooltipMessage: _calculateStatusTooltipMessage(statusTooltipProps)
        };
    });
};
